import type { Theme } from '@mui/material/styles'

import { Status } from '@/features/bidding/constants'

export function getBidStatusColor(status: Status, theme: Theme): string {
  switch (status) {
    case Status.DRAFT:
    case Status.TODO:
      return theme.palette.action.disabled
    case Status.OFFERED:
      return theme.palette.secondary.light
    case Status.ACCEPTED:
      return theme.palette.success.main
    case Status.BUYBACK:
      return theme.palette.success.dark
    case Status.MANUALLY_ACCEPTED:
    case Status.MANUALLY_EDITED:
      return '#B6A75F' // Khaki
    case Status.PARTIALLY_ACCEPTED:
      return '#96B245'
    case Status.REJECTED:
      return theme.palette.error.main
    case Status.OVERBID_ACCEPTED:
      return '#839264'
    default:
      return ''
  }
}
